import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion as Motion } from "motion/react";
import noUserImage from "@/assets/avatars/avatar-generic.webp"

export default function AmbassadorCard({ ambassador, isSelected, onToggle, showCheckbox = true }) {
  return (
    <Motion.div
      whileHover={{ scale: 1.05 }}
      className={`relative flex flex-col items-center p-3 rounded-lg transition duration-300 cursor-pointer ${
        isSelected
          ? "bg-aw-green/85 bg-opacity-20 border-2 border-aw-bluegray"
          : "bg-aw-bluedark border-2 border-aw-bluegray hover:border-aw-green"
      }`}
      onClick={onToggle}
    >
      {showCheckbox && (
        <div className="absolute top-2 right-2">
          <div
            className={`w-5 h-5 rounded border-2 flex items-center justify-center transition duration-300 ${
              isSelected
                ? "bg-aw-bluedark border-aw-bluegray text-aw-green"
                : "bg-transparent border-gray-400"
            }`}
          >
            {isSelected && (
              <FontAwesomeIcon
                icon="fa-solid fa-check"
                className="text-xs"
              />
            )}
          </div>
        </div>
      )}
      
      <img
        src={ambassador.img || ambassador.avatar || noUserImage}
        alt={ambassador.nombre || ambassador.name}
        className="w-18 h-18 rounded-full object-cover border-2 bg-aw-bluegray border-aw-green mb-2"
      />
      
      <span className={`text-sm ${isSelected ? "text-aw-bluedark" : "text-white"} text-center font-semibold line-clamp-2`}>
        {ambassador.nombre || ambassador.name}
      </span>
      
      {/* {ambassador.ticketsVendidos !== undefined && (
        <span className="text-xs text-gray-400 mt-1">
          <FontAwesomeIcon icon="fa-solid fa-ticket" className="mr-1" />
          {ambassador.ticketsVendidos} vendidos
        </span>
      )} */}
    </Motion.div>
  );
}
